import { render, staticRenderFns } from "./modal-cv-1-info.vue?vue&type=template&id=58a5504e&lang=html&"
import script from "./modal-cv-1-info.vue?vue&type=script&lang=js&"
export * from "./modal-cv-1-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports